export const ReadTextSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.66675 14.6666H12.0001C12.3537 14.6666 12.6928 14.5261 12.9429 14.2761C13.1929 14.026 13.3334 13.6869 13.3334 13.3333V4.99992L9.66675 1.33325H4.00008C3.64646 1.33325 3.30732 1.47373 3.05727 1.72378C2.80722 1.97382 2.66675 2.31296 2.66675 2.66659V4.66659"
        stroke="#A1A1AA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33325 1.33325V5.33325H13.3333"
        stroke="#A1A1AA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66659 6.66675L2.66659 8.00008H1.33325V10.6667H2.66659L4.66659 12.0001V6.66675Z"
        stroke="#A1A1AA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33325 7.33325C7.75992 7.86659 7.99992 8.57992 7.99992 9.33325C7.99992 10.0866 7.75992 10.7999 7.33325 11.3333"
        stroke="#A1A1AA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
